// extracted by mini-css-extract-plugin
export default {"cardcontainers":"project_cardcontainers__qqgtg","buttons":"project_buttons__2ObEw","techIcons":"project_techIcons__Y-ie7","readButton":"project_readButton__YEwad"};